import {Injectable, InjectionToken} from '@angular/core';
import {WindowSyncService} from '../../../core/services/window-sync.service';
import {FacilityGetlistService} from '../../apiModule/api/facility-getlist.service';
import {Observable} from 'rxjs';
import {ApiRemarktypeGetRequestParams} from '../../apiModule';

export const FACILITY_ACTIVE_SYNC = new InjectionToken<string>('FACILITY_ACTIVE_SYNC', {
    providedIn: 'root',
    factory: () => 'facility-sync'
});
export const FACILITY_IDENTIFIED_SYNC = new InjectionToken<string>('FACILITY_IDENTIFIED_SYNC', {
    providedIn: 'root',
    factory: () => 'facility-indentified-sync'
});

@Injectable({
    providedIn: 'root',
})
export class FacilityWindowSyncService extends WindowSyncService {
    constructor(private readonly facilityService: FacilityGetlistService) {
        const dataService = (params: ApiRemarktypeGetRequestParams): Observable<any> => facilityService.post(params);
        super(dataService, 'facilityIdsString');
    }
}
